import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { useAuthFieldStyles } from "./authFieldStyles";

const AuthTextField = ({
  label,
  value,
  onChange,
  error,
  type = "text",
  placeholder = "",
  onKeyUp,
  disabled = false,
  sx = {},
  ...rest
}) => {
  const classes = useAuthFieldStyles();

  return (
    <Box sx={{ width: 1, mb: "18px", ...sx }}>
      {label ? (
        <Text
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#000",
            mb: "10px",
            lineHeight: 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {label}
        </Text>
      ) : null}
      <input
        className={classes.fieldInput}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        disabled={disabled}
        {...rest}
      />
      {error ? (
        <Text sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>{error}</Text>
      ) : null}
    </Box>
  );
};

export default AuthTextField;
